import { render, staticRenderFns } from "./dutyListBatch.vue?vue&type=template&id=ab91a612&scoped=true&"
import script from "./dutyListBatch.vue?vue&type=script&lang=ts&"
export * from "./dutyListBatch.vue?vue&type=script&lang=ts&"
import style0 from "./dutyListBatch.vue?vue&type=style&index=0&id=ab91a612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab91a612",
  null
  
)

export default component.exports